/**
 * Lib.Common: v-telemetry directive
 *
 * @file
 * Marks an element for telemetry collection, if [$telemetry](#/global/telemetry) is enabled. By default, this causes
 * `click` and `hover` events to be recorded in the telemetry log.
 *
 * @value {string} - The telemetry ID associated with this element.
 */


import { add, remove } from '../global/telemetry';


function bind(el, binding) {
    el.__tm = {
        id: binding.value,
        value: binding.value
    };
    add(el);
}


function inserted(el, binding) {
    let parent = el;
    while ((parent = parent.parentElement)) {
        const tm = parent.__tm;
        if (tm) {
            el.__tm.id = tm.value + '^' + el.__tm.id;
        }
    }
}


function unbind(el) {
    delete el.__tm;
    remove(el);
}


function update(el, binding) {
    const tm = el.__tm;
    if (!tm || tm.value !== binding.value) {
        add(el, binding);
    }
}


export default {
    name: 'telemetry',
    directive: {
        bind,
        inserted,
        unbind,
        update
    }
};
